export default "__VITE_ASSET__DkPaOwXX__"